// extracted by mini-css-extract-plugin
export default {"image_side":"ActionItem_image_side__CLjKD","images_box":"ActionItem_images_box__oTvC7","main_img":"ActionItem_main_img__lOHAF","btn_action":"ActionItem_btn_action__q+40w"};